import React from 'react';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import _isEmpty from 'lodash/isEmpty';
import Message from '@app/component/message/Message';
import Portlet from '@app/component/portlet/Portlet';
import Utilities from '@util/Utilities';
import MarketStateSnapshotAnalyticalGraph
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_graph/MarketStateSnapshotAnalyticalGraph';
import MarketStateSnapshotMedianGraph
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_graph/MarketStateSnapshotMedianGraph';
import MarketAreaStateForMonthProvider
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/provider/MarketAreaStateForMonthProvider';


const MarketStateSnapshotGraphs = React.memo(() => {

	const [tab, setTab] = React.useState<'ANALYTICAL' | 'MEDIAN'>('MEDIAN');

	const tools = useMarketStateTools();

	const isNotEmpty = tools.marketStateSnapshot?.dailySnapshots?.some(ms => !_isEmpty(ms.current.competitorSnapshots));

	if (isNotEmpty) {
		return <MarketAreaStateForMonthProvider companyHotel={tools.companyHotel} calendarMonth={tools.calendarMonth}>
			<Portlet
				title={`${Utilities.snakeCaseToWords(tools.calendarMonth.index.month)} ${tools.calendarMonth.index.year} Graph`}
				note={
					<nav className="-mb-px flex items-center" aria-label="Tabs">
						<a
							className={`whitespace-nowrap px-2 text-sm font-medium cursor-pointer ${tab === 'MEDIAN' ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
							onClick={() => setTab('MEDIAN')}>
							{tools.companyHotel.comparisonLabel()}
						</a>
						<div className="h-4 w-px bg-gray-300 mx-2 hidden sm:block"></div>
						<a
							className={`whitespace-nowrap px-2 text-sm font-medium cursor-pointer ${tab === 'ANALYTICAL' ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
							onClick={() => setTab('ANALYTICAL')}>
							Analytical
						</a>
					</nav>
				}>
				{tab === 'ANALYTICAL' ? <MarketStateSnapshotAnalyticalGraph /> : <MarketStateSnapshotMedianGraph />}
			</Portlet>
		</MarketAreaStateForMonthProvider>;
	} else
		return <Message state="info">Please refresh results</Message>;
});

export default MarketStateSnapshotGraphs;